'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('colorPickerModalCtrl', [
    '$scope',
    '$rootScope',
    'BAS_SPLASH',
    'BAS_LIGHT',
    'BasLight',
    'close',
    'light',
    colorPickerModalCtrl
  ])

function colorPickerModalCtrl (
  $scope,
  $rootScope,
  BAS_SPLASH,
  BAS_LIGHT,
  BasLight,
  close,
  light
) {
  var modal = this

  var _listeners = []

  modal.BAS_LIGHT = BAS_LIGHT

  modal.close = close
  modal.BasLight = BasLight

  /**
   * @type {BasLight}
   */
  modal.light = light

  modal.getIconLabelRotation = getIconLabelRotation

  init()

  function init () {

    _listeners.push($rootScope.$on(
      BAS_SPLASH.EVT_SPLASH_VISIBILITY_CHANGED,
      _onSplashVisibility
    ))

    $scope.$on('$destroy', onDestroy)
  }

  function getIconLabelRotation (label) {
    switch (label) {
      case '#[up]':
        return { transform: 'rotate(0deg)' }
      case '#[right]':
        return { transform: 'rotate(90deg)' }
      case '#[down]':
        return { transform: 'rotate(180deg)' }
      case '#[left]':
        return { transform: 'rotate(-90deg)' }
      default:
        return { transform: 'rotate(0deg)' }
    }
  }

  function _onSplashVisibility () {

    close()
  }

  function onDestroy () {

    BasUtil.executeArray(_listeners)
    _listeners = []
  }
}
